import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getAllUrlParams, getUrlParam } from "./utils/urlParams";
import axios from "axios";
import * as microsoftTeams from "@microsoft/teams-js";
const withInitialData = (WrappedComponent) => {
  return function WrappedWithInitialData(props) {
    const location = useLocation();
    const [initialData, setInitialData] = useState(null);
    const [ResponseData, setResponseData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [context, setContext] = useState(null);
    const [isTeams, setIsTeams] = useState(false);
    const baseURL = "https://amplifai-reactjs-webapi.azurewebsites.net/api/";
    const teamValidateURL = "Login/ValidateMsTeamUserCredential";
    // const QAURL = "Login/GetClaimsValidateUserLoginFromCosmos";
    const QAURL = "React/GetClaimsValidateUserLoginFromCosmosReact";

    useEffect(() => {
      const { appmode, loginmode, companyguid, agent, appdata } =
        getAllUrlParams();
      let appMode = appmode || loginmode;
      const fetchData = async (url, Param) => {
        try {
          const response = await axios.get(baseURL + url, {
            params: { ...Param },
          });
          const data = response?.data;
          // Validate API response: ensure data exists and is not an empty array.
          if (!data || data.length === 0) {
            setError({
              title: "No User Details Found",
              message:
                "We could not find any user details for the provided Company ID and Agent ID. Please verify the link or contact support.",
              code: "USER_NOT_FOUND",
            });
            return;
          }
          setInitialData(data[0]);
          setResponseData(response);
          sessionStorage.setItem("currentCompany", data[0]?.comapnyGuid);
        } catch (error) {
          setError({
            title: "Login Validation Failed",
            message:
              error?.response?.data?.message ||
              "Unable to validate user login. Please try again.",
            code: error?.response?.status || "API_ERROR",
          });
        } finally {
          setLoading(false);
        }
      };
      if (appMode === "teams") {
        // Initialize the Microsoft Teams SDK
        microsoftTeams.app
          .initialize()
          .then(() => {
            // Get the context

            setIsTeams(true);
            microsoftTeams.app
              .getContext()
              .then((context) => {
                setContext(context);
                let tenantID = context?.user.tenant?.id;
                let teamsUserID = context?.user.id;
                // let tenantID = "291d28d3-bc04-412d-95da-9fc83f648860";
                // let teamsUserID = "61faa81c-2c11-40c7-ac0a-d0bc45dcb6e0";
                const teamsParam = {
                  tenantID: tenantID,
                  teamsUserID: teamsUserID,
                  teamsAadObjectId: "NA",
                };
                fetchData(teamValidateURL, teamsParam);
              })
              .catch((error) => {
                console.error("Error getting context:", error);
              });
          })
          .catch((error) => {
            console.error("Error initializing Teams SDK:", error);
          });

        // let tenantID = urlParams.get("tenantID");
        // let teamsUserID = urlParams.get("teamsUserID");
        // let teamsAadObjectId = urlParams.get("teamsAadObjectId");
        // const teamsParam = {
        //   tenantID: tenantID,
        //   teamsUserID: teamsUserID,
        //   teamsAadObjectId: teamsAadObjectId,
        // };
        // fetchData(teamValidateURL, teamsParam);
      } else if (appdata !== undefined && appdata !== null) {
        const QAparam = {
          data: appdata,
        };
        fetchData(QAURL, QAparam);
      } else {
        setError({
          title: "Unable to Launch Dashboard",
          message:
            "The application was opened without a valid login mode. Required access parameters are missing or invalid. Please open the dashboard using a valid link.",
          code: "INVALID_LAUNCH_PARAMS",
        });

        setLoading(false);
      }
    }, [location.search]);

    if (loading) {
      return <div className="loading">Loading...</div>;
    }

    if (error) {
      return (
        <div className="d-flex align-items-center justify-content-center vh-100">
          <div className="text-center px-3">
            <h4 className="text-danger mb-2">
              {error.title || "Something went wrong"}
            </h4>

            <p className="text-muted mb-3">
              {error.message ||
                "An unexpected error occurred while launching the dashboard."}
            </p>

            {error.code && (
              <small className="text-muted">Error Code: {error.code}</small>
            )}
          </div>
        </div>
      );
    }

    return (
      <WrappedComponent
        initialData={initialData}
        ResponseData={ResponseData}
        context={context}
        isTeams={isTeams}
        {...props}
      />
    );
  };
};

export default withInitialData;
